@Controller('ib-commons-modal-service-module')
class ibLoadingPlaneController implements ng.IController {
    constructor () {
    }
}
